import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GCAuthenticationService } from 'src/app/billing/shared/service/gc-authentication.service';
import { GknRoutePath } from 'src/app/app-routing.enum';

export const gcTokenGuard: CanActivateFn = (route): boolean => {
    const gcAuthService = inject(GCAuthenticationService);
    const router = inject(Router);

    if (gcAuthService.getPKCETokenFromSession()) return true;
    if (route.queryParamMap.get('login') === 'true') return true;

    router.navigate([`/${GknRoutePath.BILLING}`], { queryParams: { login: true } });
    return false;
};
